import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-users',
  templateUrl: './users-users.component.html',
  styleUrls: ['./users-users.component.scss']
})
export class UsersUsersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
